{
  "id": 25,
  "location": "paris",
  "difficulty": "normal",
  "moves": 22,
  "kinds": 6,
  "goals": [
    { "type": "collect", "kind": "cupcake", "count": 34 },
    { "type": "collect", "kind": "croissant", "count": 34 },
    { "type": "mud" }
  ],
  "stars": [4460, 5540],
  "board": [
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . X . x . .",
    ". . . X . x . .",
    ". . . . . . . ."
  ],
  "calibration": { "runs": 1000, "winRate": 0.642, "movesLeft": 4.4, "closeLosses": 0.123, "target": 0.69 }
}
